import {
  useIndividualsServiceGetV1IndividualsByIndividualIdKey,
  useIndividualsServiceGetV1IndividualsByIndividualIdRegenStatusKey,
  useServiceGroupsServiceGetV1IndividualsByIndividualIdServiceGroupsKey,
  useUsersServiceGetV1UsersMeKey,
} from '../client/queries/common'

// The individual is read directly and via the user's individuals list.
export const INDIVIDUAL_INVALIDATION_KEYS = [
  useIndividualsServiceGetV1IndividualsByIndividualIdKey,
  useUsersServiceGetV1UsersMeKey,
]

// Everything a regen rewrites — the individual (description + regen state) plus
// its Hitta stöd generations and regen status.
export const REGEN_INVALIDATION_KEYS = [
  ...INDIVIDUAL_INVALIDATION_KEYS,
  useServiceGroupsServiceGetV1IndividualsByIndividualIdServiceGroupsKey,
  useIndividualsServiceGetV1IndividualsByIndividualIdRegenStatusKey,
]
